<template>
    <input :name="name" class="tagify-input" type="text" v-model=" tagValue " autocomplete :placeholder="placeholder">
</template>

<script>
    import Tagify from "@yaireo/tagify";
    import '@yaireo/tagify/dist/tagify.css';

    export default {
        name: 'Tagify',
        props: {
            routeAutocomplete: {
                type: String,
                required: false
            },
            name: {
                type: String,
                required: true,
            },

            routeSearch: {
                type: String,
                required: false
            },
            allowNew: {
                type: Boolean,
                required: false,
                default: false
            },
            value: {
                type: String,
                required: false,
                default: '[]'
            },
            creatingTags: {
                type: Boolean,
                required: false,
                default: false
            },
            mode: {
                type: String,
                required: false,
            },
            placeholder: {
                type: String,
                required: false,
                default: 'Search by tags'
            },
            whitelist: {
                type: Array,
                required: false,
            }
        },
        data() {
            return {
                tagify: null,
                tagValue: null,
                initialTags: [],
                wlist: []
            };
        },
        computed: {
            enforceWhitelist: function() {return !this.allowNew;},
            baseName() {
                if( ! this.name.includes('[')) {return this.name;}
                let split = this.name.split('[');
                return split[0];
            },
            key() {
                if( ! this.name.includes('[')) {return null;}
                let split = this.name.split('[');
                return split[1].slice(0, -1);
            },
        },
        watch: {
            value: function(newValue, oldValue) {
                this.tagValue = newValue;
                if(this.tagValue === '' || this.tagValue === '[]') this.tagify.removeAllTags();
            }
        },
        mounted() {
            this.initialTags = this.value !== '[]' && this.value !== '' ? (Array.isArray(this.value) ? this.value : JSON.parse(this.value)) : [];

            if (this.$store.state.old[this.baseName]) {
                let temp;
                if (this.$isIterable(this.$store.state.old[this.baseName])) {
                    temp = this.$store.state.old[this.baseName][this.key] ? this.$store.state.old[this.baseName][this.key] : [];
                } else {
                    temp = this.$store.state.old[this.baseName];
                }
                this.initialTags = temp !== '[]' && temp !== '' ? (Array.isArray(temp) ? temp : JSON.parse(temp)) : [];
            }

            this.wlist = this.whitelist || this.initialTags;


            let options = {
                whitelist: this.wlist,
                dropdown: {
                    enabled: 2
                },
                enforceWhitelist: this.enforceWhitelist
            };
            if(this.mode === 'select') {
                options.mode = 'select';
            }

            this.tagify = new Tagify(this.$el, options);
            this.tagify.on('add', this.onTagAdd);
            this.tagify.on('remove', this.onTagRemove);
            this.tagify.on('input', this.onInput);

            this.tagify.addTags(this.initialTags);

            this.onTagAdd();
        },

        methods: {
            onTagAdd: function(e) {
                if(this.routeSearch) {
                    let value = this.$el.value;

                    if (!value || !value.length) {
                        this.$store.commit('filteredMedia', null);
                        return;
                    }

                    this.$http.post(this.routeSearch, {
                        filters: JSON.parse(value)
                    })
                    .then( (response) => {
                        this.$d(response);
                        this.$store.commit('filteredMedia', response.data);
                    })
                    .catch( (error) => {
                        this.$displayError(error);
                    });
                }
                this.tagValue = this.$el.value;
                this.$emit('input', this.$el.value);
            },
            onTagRemove: function(e) {
                this.onTagAdd(e);
            },
            onInput: function(e) {
                if(this.routeAutocomplete) {
                    let val = e.detail.value;
                    if (!val || !val.length) return;

                    this.$http.post(this.routeAutocomplete, {
                        name: val,
                        _token: this.$store.state.csrfToken
                    })
                        .then((response) => {
                            this.tagify.settings.whitelist = response.data;
                            if (this.creatingTags) {
                                this.tagify.settings.blacklist = response.data;
                            }
                        })
                        .catch((error) => {
                            this.$displayError(error);
                        });
                }
            }
        }
    }

</script>

<style>
    .tagify-input {
        height: auto;
        overflow: auto;
    }
</style>
